// extracted by mini-css-extract-plugin
module.exports = {"navigation":"style_navigation__Y2eSg","active":"style_active__DnuMi"};